import axios from "axios";
import { getPlatformType } from "shared/utils/platform";

const VOOPTER_DOMAIN = ".voopter.com.br";

const getCurrentVoopterClientVersion = () =>
  new Date().toISOString().slice(0, 10).split("-").reverse().join("-");

const httpService = axios.create({
  timeout: 10000,
  headers: {
    "Content-Type": "application/xml",
    Accept: "application/xml",
  },
});

httpService.interceptors.request.use((config) => {
  if (config.url?.includes(VOOPTER_DOMAIN)) {
    config.headers.set("X-Voopter-Client", getPlatformType());
    config.headers.set(
      "X-Voopter-Client-Version",
      getCurrentVoopterClientVersion(),
    );
  }

  return config;
});

httpService.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("HTTP Error:", error.response || error.message);
    return Promise.reject(error);
  },
);

export const get = (url: string, headers = {}) =>
  httpService.get(url, { headers });

export const post = (url: string, data: unknown, headers = {}) =>
  httpService.post(url, data, { headers });

export default httpService;
